import { forwardRef, useRef, useState, useEffect } from 'react';
import IMask from 'imask';
import { jsx } from 'react/jsx-runtime';
import { TextField } from '../text-field/components.js';

const MaskType = {
  Range: IMask.MaskedRange
};
const TextFieldMasked = /*#__PURE__*/forwardRef(function TextFieldMasked(_ref, ref) {
  let {
    name,
    value,
    onAccept,
    onComplete,
    maskOptions,
    ...rest
  } = _ref;
  const internalRef = useRef();
  const inputRef = ref ?? internalRef;
  const [mask, setMask] = useState(null);
  const [maskedValue, setMaskedValue] = useState(value ?? undefined);
  useEffect(() => {
    if (value !== undefined) {
      setMaskedValue(value);
    }
  }, [value]);
  useEffect(() => {
    if (inputRef.current && !mask) {
      setMask(IMask(inputRef.current, {
        ...maskOptions
      }));
    }
  }, [mask, maskOptions]);
  useEffect(() => {
    if (inputRef.current) {
      if (mask) {
        /** workaround for a known issue in the imask lib can be removed is 'mask.updateValue()' is fixed  */
        if (!onAccept) {
          mask.on("accept", () => {
            if (inputRef.current) {
              setMaskedValue(inputRef.current.value);
            }
          });
        }
        if (onAccept) {
          mask.on("accept", () => {
            if (inputRef.current) {
              setMaskedValue(inputRef.current.value);
              onAccept({
                name,
                value: inputRef.current.value,
                unmaskedValue: mask.unmaskedValue,
                typedValue: mask.typedValue
              }, inputRef);
            }
          });
        }
        if (onComplete) {
          mask.on("complete", () => {
            if (inputRef.current) {
              onComplete({
                name,
                value: inputRef.current.value,
                unmaskedValue: mask.unmaskedValue,
                typedValue: mask.typedValue
              }, inputRef);
            }
          });
        }
      }
    }
    return () => {
      if (mask) {
        mask.off("accept");
        mask.off("complete");
      }
    };
  }, [mask, name, onAccept, onComplete, value]);
  return /*#__PURE__*/jsx(TextField, {
    name: name,
    value: maskedValue,
    ref: inputRef,
    ...rest
  });
});

export { MaskType, TextFieldMasked };
//# sourceMappingURL=index.js.map
